<template>
  <AppSelect v-model="urgency" :items="['none', ...props.urgencies.map(u => u.speed)]">
    <template #label>
      {{ $tt(`priority.${isAppointment ? 'label_appointment' : 'processing_time'}`) }}
    </template>
    <template #item="{ item }">
      <UrgencySelectOption
        :fee="getFee(item.value)"
        :value="item.value"
        :is-appointment="isAppointment"
      />
    </template>
    <template #selection="{ item }">
      <UrgencySelectOption
        :fee="getFee(item.value)"
        :value="item.value"
        :is-appointment="isAppointment"
      />
    </template>
  </AppSelect>
</template>

<script setup lang="ts">
import type { VisaForm, Urgency } from '~/types';

const props = defineProps<{
  urgencies: Urgency[];
  isAppointment: boolean;
}>();

const urgency = defineModel<VisaForm['urgency']>({ required: true });

const ZERO_PRICE: Urgency['fee'] = { ils: 0, usd: 0, sek: 0, rub: 0, kzt: 0 };

function getFee(value: string) {
  if (value === 'none') return ZERO_PRICE;
  const found = props.urgencies.find(u => u.speed === value);
  return found ? found.fee : ZERO_PRICE;
}
</script>